<template>
  <ui-modal-layout :title="tr('Activate your subscription')">
    <lottie-animation
      ref="welcomeAnimation"
      class="mx-auto w-full max-w-72"
      :animation-data="require('@/assets/lottie/shoprenter-welcome-owl.json')"
      :auto-play="false"
      :loop="true"
    />
    <p class="m-0 text-center text-muted-foreground">
      {{ tr('You don\'t have an active subscription yet. To start using the service, please initiate a subscription.') }}
    </p>

    <template #footer>
      <ui-button class="w-full" :disabled="isLoading" @click="() => startSubscription()">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Start subscription') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';
import { LottieAnimation } from 'lottie-web-vue';

import ShoprenterService from '@/services/Shoprenter';

export default {
  name: 'ShoprenterStartSubscriptionModal',
  components: {
    LoaderCircleIcon: LoaderCircle,
    LottieAnimation,
  },
  data: () => ({
    isLoading: false,
  }),
  mounted() {
    setTimeout(() => {
      this.$refs.welcomeAnimation.setSpeed(0.5);
      this.$refs.welcomeAnimation.play();
    }, 1000);
  },
  methods: {
    startSubscription() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      ShoprenterService.createCharge()
        .then(resp => {
          window.top.location.href = resp.confirmationUrl;
          return resp;
        })
        .catch(err => {
          this.isLoading = false;
          this.error(err);
        });
    },
  },
};
</script>
